import Experience from './Experience'
import * as THREE from 'three'
import type Sizes from './Utils/Sizes';

export default class Renderer
{
    experience: Experience
    canvas: HTMLCanvasElement | null
    scene: THREE.Scene
    sizes: Sizes
    camera: THREE.Camera
    instance: THREE.WebGLRenderer

    constructor(experience: Experience)
    {
        this.experience = experience
        this.canvas = this.experience.canvas
        this.scene = this.experience.scene
        this.sizes = this.experience.sizes
        this.camera = this.experience.camera.instance
        this.instance = new THREE.WebGLRenderer()
        this.setInstance()
    }

    setInstance()
    {
        this.instance = new THREE.WebGLRenderer({
            canvas: this.canvas ?? undefined,
            antialias: true
        })
        // this.instance.toneMapping = THREE.CineonToneMapping
        // this.instance.toneMappingExposure = 1.75
        // this.instance.shadowMap.enabled = true
        // this.instance.shadowMap.type = THREE.PCFSoftShadowMap
        // this.instance.setClearColor('#211d20')
        this.instance.setClearColor(0x000000, 0)
        this.instance.setSize(this.sizes.width, this.sizes.height)
        this.instance.setPixelRatio(this.sizes.pixelRatio)
        // console.log(this.instance);
    }
    resize()
    {
        this.instance.setSize(this.sizes.width, this.sizes.height)
        this.instance.setPixelRatio(this.sizes.pixelRatio)
    }
    update()
    {
        this.instance.render(this.scene, this.camera)
    }
}